import React, { useContext } from 'react';
import styled from 'styled-components';

import ThemeContext from '../../../theme/ThemeContext';

const StyledLabel = styled.div`
  display: flex;
  font-weight: 500;
  font-size: 14px;
  padding: 8px;
  flex: 1;
  color: ${(props) => props.theme.fontColorPrimary};
`;

/**
 * Style wrapper for consistent section labels.
 * It's goal is to match fields wrapped in accordions.
 */
export default ({ children }) => {
  const theme = useContext(ThemeContext);
  return (<StyledLabel theme={theme}>{children}</StyledLabel>);
};
